import React from 'react'
import { useForm } from 'react-hook-form'
import { IRotationForm } from 'safe'
import { IBatch, ICreateBatchDTO, setRotation } from '../../common/Inventory/Rotation'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import Datepicker from '../../components/Inputs/Datepicker'
import InputText from '../../components/Inputs/InputText'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { getYearMonthAndDay, transformDate } from '../../utils/utils'

const RotationForm: React.FC<RotationFormProps> = ({
  id_item,
  batchProp = null,
  onClose,
  cancelText = 'Cancelar',
  onPurchase = null,
  submitText = 'Guardar',
  setNewRotation,
  hasTitle = true
}) => {
  // const { rotation_date, creation_date, expiration_date, batch } = batchProp

  const { addAlert } = useSnackBars()

  const rotation_date = batchProp?.rotation_date
    ? transformDate(batchProp.rotation_date)
    : null
  const creation_date = batchProp?.creation_date
    ? transformDate(batchProp.creation_date)
    : null
  const expiration_date = batchProp?.expiration_date
    ? transformDate(batchProp.expiration_date)
    : null
  const batch = batchProp?.batch ? batchProp.batch : ''

  const monitorForm = useForm({
    defaultValues: {
      batch,
    },
  })

  const handleSubmit = async (values: InputProps) => {
    try {
      const [year, month, day] = getYearMonthAndDay(values.creationDate)
      const creationD = new Date(year, month, day)

      const [year2, month2, day2] = getYearMonthAndDay(values.expirationDate)
      const expirationD = new Date(year2, month2, day2)

      const [year3, month3, day3] = getYearMonthAndDay(values.rotationDate)
      const rotationD = new Date(year3, month3, day3)

      if (creationD.getTime() > expirationD.getTime()) {
        addAlert({
          message: 'Fecha de creación debe ser menor a la fecha de expiración',
          status: 'error',
        })
        return
      }

      if (rotationD.getTime() > expirationD.getTime()) {
        addAlert({
          message: 'Fecha de rotación debe ser menor a la fecha de expiración',
          status: 'error',
        })
        return
      }

      if (rotationD.getTime() < creationD.getTime()) {
        addAlert({
          message: 'Fecha de rotación debe ser mayor a la fecha de creación',
          status: 'error',
        })
        return
      }

      if (onPurchase) {
        const pendingRotation: IRotationForm = {
          creation_date: values.creationDate,
          expiration_date: values.expirationDate,
          rotation_date: values.rotationDate,
          batch: values.batch,
          id_item,
        }
        onPurchase(pendingRotation)
        return
      }

      // const newRotation: ICreateBatchDTO = {
      //   ...values,
      //   id_item,
      // }

      
      let valuesFormatter = {
        creationDate: creationD.toISOString(),
        expirationDate: expirationD.toISOString(),
        rotationD: rotationD.toISOString(),
        batch: values.batch
      }

      setNewRotation && setNewRotation(id_item, valuesFormatter)

      // addAlert({ message: 'Actualizando rotación...', status: 'loading' })
      // const response = await setRotation(newRotation)
      // const batch: IBatch = {
      //   batch: response.batch,
      //   creation_date: response.creationDate,
      //   expiration_date: response.expirationDate,
      //   id: response.id,
      //   id_item: response.id_item,
      //   rotation_date: response.rotationDate
      // }
      // setNewRotation &&  setNewRotation(id_item, batch)
      // addAlert({
      //   message: 'Rotación actualizada con éxito!',
      //   status: 'success',
      // })
      // onClose()
    } catch (error) {
      console.log(error)
      addAlert({
        message: 'Error al actualizar rotación',
        status: 'error',
      })
    } finally {
    }
  }

  return (
    <Form
      form={monitorForm}
      classes={`gap-x-6 gap-y-2`}
      onSubmit={(values) => handleSubmit(values)}
    >
      <h2 className="col-span-12 text-primary-900 font-bold dark:text-white mb-3">
        {hasTitle && "Monitoreo del Producto"}
      </h2>
      <FormItem
        name="creationDate"
        classes="xl:col-span-6 col-span-12"
        rules={{
          required: 'Debe especificar la fecha de creación del producto',
        }}
        defaultValue={creation_date}
      >
        <Datepicker label="Fecha de Elaboración" />
      </FormItem>

      <FormItem
        name="expirationDate"
        classes="xl:col-span-6 col-span-12"
        rules={{
          required: 'Debe especificar la fecha de expiración del producto',
        }}
        defaultValue={expiration_date}
      >
        <Datepicker label="Fecha de Vencimiento" />
      </FormItem>

      {onPurchase ? (
        <FormItem name="batch" classes="xl:col-span-6 col-span-12">
          <InputText small label="Lote" maxLength={80} />
        </FormItem>
      ) : (
        <FormItem
          name="batch"
          classes="xl:col-span-6 col-span-12"
          rules={{
            required: 'Es necesario el código del lote',
          }}
        >
          <InputText small label="Lote" maxLength={80} />
        </FormItem>
      )}

      <FormItem
        name="rotationDate"
        classes="xl:col-span-6 col-span-12"
        rules={{
          required: 'Debe especificar la fecha de rotación del producto',
        }}
        defaultValue={rotation_date}
      >
        <Datepicker label="Fecha de Rotación" />
      </FormItem>

      <div className='h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 mt-5'></div>


      <div className="col-span-12 flex space-x-2 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onClose()}
          htmlType="button"
        >
          {cancelText}
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          {submitText}
        </Button>
      </div>
    </Form>
  )
}

interface RotationFormProps {
  id_item: string
  batchProp?: {
    creation_date: string
    expiration_date: string
    rotation_date: string
    batch: string
  }
  onClose: Function
  setNewRotation?: (idItem: string, batch: any) => void
  cancelText?: string
  onPurchase?: Function | null
  submitText?: string
  hasTitle?: boolean
}

interface InputProps {
  batch: string
  creationDate: string
  expirationDate: string
  rotationDate: string
}

export default RotationForm
